module.exports = __webpack_public_path__ + "static/img/starCourse.52d4a23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/starCourse.png
// module id = yLR0
// module chunks = 1